import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { STATIC_PATH_S3 } from '../../config';
import MainLink from '../../components/MainLink/MainLink';

const HeaderMain = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        isMenuOpen &&
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        closeMenu();
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, [isMenuOpen, closeMenu]);

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === 'Escape' && isMenuOpen) {
        closeMenu();
      }
    };

    document.addEventListener('keydown', handleEscapeKey);
    return () => document.removeEventListener('keydown', handleEscapeKey);
  }, [isMenuOpen, closeMenu]);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  return (
    <header className="header-main">
      <div className="header-main__container">
        <div className="header-main__inner">
          <Link className="logo logo--dark" to="/publisher/sign_in">
            <span className="logo__img-svg" />
            <span className="logo__subtext">Партнерская программа</span>
          </Link>

          <button
            ref={buttonRef}
            className={`header-main__burger-menu ${isMenuOpen ? 'active' : ''}`}
            onClick={toggleMenu}
            aria-label={isMenuOpen ? 'Закрыть меню' : 'Открыть меню'}
            aria-expanded={isMenuOpen}
          >
            <svg
              className="header-main__burger-menu-icon"
              width="30"
              height="21"
              viewBox="0 0 30 21"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                className="header-main__burger-menu-line header-main__burger-menu-line--top"
                x="0"
                y="0"
                width="30"
                height="3"
                rx="1.5"
              ></rect>
              <rect
                className="header-main__burger-menu-line header-main__burger-menu-line--mid"
                x="0"
                y="9"
                width="30"
                height="3"
                rx="1.5"
              ></rect>
              <rect
                className="header-main__burger-menu-line header-main__burger-menu-line--bot"
                x="0"
                y="18"
                width="30"
                height="3"
                rx="1.5"
              ></rect>
            </svg>
          </button>

          <nav
            ref={menuRef}
            className={`header-main__nav-menu ${isMenuOpen ? 'active' : ''}`}
            aria-hidden={!isMenuOpen}
          >
            <MainLink
              className="header-main__nav-btn"
              variant="white"
              to="/publisher/sign_in"
              onClick={closeMenu}
            >
              Войти
            </MainLink>
            <MainLink
              className="header-main__nav-btn"
              variant="black"
              to="/publisher/sign_up"
              onClick={closeMenu}
            >
              Зарегистрироваться
            </MainLink>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default HeaderMain;
